// @generated by TypeGen from LogbookModel/Account.swift - DO NOT EDIT

import type { ICursor } from "../LogbookFoundation/Cursor"
import type { ICruise } from "./Cruise"
import type { IDay } from "./Day"
import type { ILog } from "./Log"
import type { INote } from "./Note"
import type { ISearchResult } from "./Searchable"
import type { ITrip } from "./Trip"

export interface IAccount {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  accountSubscriptionPlanId: number;
  name: string;
  slug: string;
  metadata: string;
  nextBillingAt?: string;
  subscriptionStatus?: IAccountSubscriptionStatus;
  subscriptionInterval?: IAccountSubscriptionInterval;
  trialFirstDay?: number;
  paymentSystem?: IAccountPaymentSystem;
}

export interface IAccountSearchResult {
  cursor: ICursor;
  results: ISearchResult[];
}

export type IAccountSearchResults = Record<string, IAccountSearchResult>;

export interface IAccountSearchResponse {
  results: IAccountSearchResults;
  cruises: ICruise[];
  days: IDay[];
  logs: ILog[];
  notes: INote[];
  trips: ITrip[];
}

export enum IAccountPaymentSystem {
  none = 0,
  stripe = 1,
  apple = 2,
  gift = 3,
}

export enum IAccountSubscriptionInterval {
  monthly = 0,
  yearly = 1,
  quarterly = 2,
}

export enum IAccountSubscriptionStatus {
  inactive = 0,
  trial1DayLeft = 1,
  trial2DaysLeft = 2,
  trial3DaysLeft = 3,
  trial4DaysLeft = 4,
  trial5DaysLeft = 5,
  trialStarted = 7,
  trialExpired = 8,
  active = 10,
  cancelled = 11,
}
